// extracted by mini-css-extract-plugin
export var tosLink = "_ai-0";